import { BlockWidthWrapper } from '@infl-ts/util-block-width-context';
import { Box, useMediaQuery } from '@mui/material';
import { pipe } from 'fp-ts/function';
import * as RA from 'fp-ts/ReadonlyArray';
import { UnknownBlockList } from '../../unknown-block-list';
import { jsx as _jsx } from "react/jsx-runtime";

var ColumnBlock = function ColumnBlock(_ref) {
  var _ref$block = _ref.block,
      widths = _ref$block.widths,
      columns = _ref$block.columns,
      href = _ref.href,
      leafBlocks = _ref.leafBlocks;
  var isTablet = useMediaQuery(function (theme) {
    return theme.breakpoints.down('lg');
  });
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      mx: 3,
      my: 4
    },
    "data-element": "Box",
    "data-component": "ColumnBlock",
    "data-source-file": "index.tsx",
    children: /*#__PURE__*/_jsx(BlockWidthWrapper, {
      "data-element": "BlockWidthWrapper",
      "data-component": "ColumnBlock",
      "data-source-file": "index.tsx",
      children: /*#__PURE__*/_jsx(Box, {
        sx: {
          display: 'flex',
          flexDirection: isTablet ? 'column' : 'row',
          columnGap: 4
        },
        "data-element": "Box",
        "data-component": "ColumnBlock",
        "data-source-file": "index.tsx",
        children: pipe(columns, RA.mapWithIndex(function (i, column) {
          return /*#__PURE__*/_jsx(Box, {
            sx: {
              width: isTablet ? '100%' : widths[i].toString() + '%',
              overflow: 'hidden',
              p: 0.125,
              display: 'flex',
              flexDirection: 'column',
              gap: 4
            },
            children: /*#__PURE__*/_jsx(UnknownBlockList, {
              blocks: column,
              href: href,
              leafBlocks: leafBlocks
            })
          }, i);
        }))
      })
    })
  });
};

export default ColumnBlock;